import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const InfluenzaAvoidSymptoms = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding7rem1 pt-md-5 pb-md-3 pb-lg-5 pb-0 pt-4  bg-img' style={{ backgroundImage:"url('influenza-testing/ULC-Testing-bg-v1.png')"}}>
            <Row className='reverse-section'>
                <Col sm='12' md='12' lg='6' className=''>
                    <div className='flex-center pt-md-4 pt-lg-0 pt-5'>
                        <img src='influenza-testing/Influenza-Testing-img1.png' alt='Avoid Influenza Symptoms' className='img-w16' />
                    </div>
                </Col>

                <Col sm='12' md='12' lg='6' className='ps-md-0'>
                    <div className='pe-md-5'>
                        <div className='pb-3'>
                            <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                                AVOIDING FLU-LIKE SYMPTOMS
                            </div>
                            <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>

                        <div className='pb-3'>
                            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black lh-1-6' style={{ letterSpacing:'0.5px'}}>
                            The primary step is to get an influenza test near you and know if you have flu or Covid-19. If necessary, your doctor may give you medicine to fight the virus. The medication is known as an antiviral medication. It works best when you start using it within two days of feeling sick. Taking antiviral medication may reduce symptoms of the flu.
                            </div>
                        </div>

                        <div className=''>
                        <Link to='/book-panel-test-appointment'>
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-16-1' style={{ padding:'',}}>
                                    BOOK YOUR RSV TEST
                                </text>
                            </Button>
                        </Link>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default InfluenzaAvoidSymptoms